import PaintbrushIcon from "../icons/content-pages/PaintbrushIcon";
import OrderPrintIcon from "../icons/OrderPrintIcon";
import CompassIcon from "../icons/CompassIcon";
import CartIcon from "../icons/CartIcon";
import Folder2Icon from "../icons/Folder2Icon";
import UploadIcon from "../icons/UploadIcon";
import TemplatesIcon from "../icons/TemplatesIcon";
import OrderingMenuIcon from "../icons/OrderingMenuIcon";
import ChooseTemplateIcon from "../icons/content-pages/ChooseTemplateIcon";
import DesignSetsIcon from "../icons/content-pages/DesignSetsIcon";
import PricingIcon from "../icons/PricingIcon";
import WebIcon from "../icons/WebIcon";
import LinkPages2Icon from "../icons/LinkPages2Icon";
import CustomerServiceIcon from "../icons/content-pages/CustomerServiceIcon";
import PrinterIcon from "../icons/content-pages/PrinterIcon";
import MegaphoneIcon from "../icons/content-pages/MegaphoneIcon";
import UserIcon from "../icons/UserIcon";
import ChangeLocationIcon from "../icons/ChangeLocationIcon";
import { ProStar } from "../account/misc/ProStar";
import { 
  DeleteOutlined,
  VerticalAlignBottomOutlined,
  ImportOutlined,
  UnlockOutlined,
  PlusOutlined,
  MinusOutlined,
  SearchOutlined,
  EyeOutlined,
  MoreOutlined,
  DownOutlined,
  LeftOutlined,
  RightOutlined,
  UpOutlined,
  CloseOutlined,
  FontColorsOutlined,
  BoldOutlined,
  ItalicOutlined,
  UnderlineOutlined,
  FontSizeOutlined,
  AlignLeftOutlined,
  AlignCenterOutlined,
  AlignRightOutlined,
  CopyOutlined,
  EnvironmentOutlined,
  EditOutlined,
  FilePdfOutlined,
  MailOutlined,
  ClockCircleOutlined,
  StarOutlined,
  BarsOutlined,
  QrcodeOutlined,
  LinkOutlined,
  HeartOutlined,
  GlobalOutlined,
  ShopOutlined,
  CalendarOutlined,
  PictureOutlined,
  BgColorsOutlined,
  SettingOutlined,
  MessageOutlined,
  PhoneOutlined,
  HomeOutlined,
  AppstoreOutlined,
  CreditCardOutlined,
  DollarOutlined,
  WarningOutlined,
  CheckCircleOutlined,
  QuestionCircleOutlined
 } from "@ant-design/icons";
import { Button } from "antd";

export interface DigitalAssetsIconographyProps {
  downloadZip: (name: string) => void;
}

export function DigitalAssetsIconography({downloadZip}: DigitalAssetsIconographyProps) {
  return (
    <div className={"scroll-area iconography"}>
      <div className={"assets-banner mobile-only"}>
        <div>
          <p>Brand Elements</p>
          <div className={"border-el"}/>
          <h1>Iconography</h1>
        </div>
      </div>
      <section className={"one"}>
        <h2>Custom Icons</h2>
        <p>We use single color, 2D line icons in our brand dark grey (#333333). These are used to illustrate certain product features or aspect of our software.</p>
        <Button className={"mobile-only download-btn"} onClick={() => downloadZip('Icons')}><VerticalAlignBottomOutlined/>Download Icons</Button>
        <div className={"icons"}>
          <div><PaintbrushIcon/></div>
          <div><OrderPrintIcon/></div>
          <div><CompassIcon/></div>
          <div><CartIcon/></div>
          <div><Folder2Icon/></div>
          <div><UploadIcon/></div>
          <div><TemplatesIcon/></div>
          <div><OrderingMenuIcon/></div>
          <div><ChooseTemplateIcon/></div>
          <div><DesignSetsIcon/></div>
          <div><PricingIcon/></div>
          <div><WebIcon/></div>
          <div><LinkPages2Icon/></div>
          <div><CustomerServiceIcon/></div>
          <div><PrinterIcon/></div>
          <div><MegaphoneIcon/></div>
          <div className={"stroke"}><UserIcon/></div>
          <div><ChangeLocationIcon/></div>
        </div>
        <div className={"icons-with-text"}>
          <div className={"location"}><ChangeLocationIcon/></div>
          <div className={"user"}><UserIcon/></div>
          <div className={"pro-star-cont"}><ProStar/></div>
          <p><b>Note:</b> The only icons that use a color other than dark grey are the ones used for Locations, Teams, and Pro Plan marketing.</p>
        </div>
      </section>
      <section className={"two"}>
        <h2>Utility Icons</h2>
        <p>The utility icons we use throughout our site are from the <a href="https://ant.design/components/icon">Ant Design Library</a>. Below are some of the frequently most used.</p>
        <div className={"icons anticons"}>
          {// not found: Remove folder, uppercase, location, web
          }
          <div><DeleteOutlined/></div>
          <div><VerticalAlignBottomOutlined/></div>
          <div><ImportOutlined/></div>
          <div><UnlockOutlined/></div>
          <div><PlusOutlined/></div>
          <div><MinusOutlined/></div>
          <div><SearchOutlined/></div>
          <div><EyeOutlined/></div>
          <div><MoreOutlined/></div>
          <div><DownOutlined/></div>
          <div><LeftOutlined/></div>
          <div><RightOutlined/></div>
          <div><UpOutlined/></div>
          <div><CloseOutlined/></div>
          <div><FontColorsOutlined/></div>
          <div><BoldOutlined/></div>
          <div><ItalicOutlined/></div>
          <div><UnderlineOutlined/></div>
          <div><FontSizeOutlined/></div>
          <div><AlignLeftOutlined/></div>
          <div><AlignCenterOutlined/></div>
          <div><AlignRightOutlined/></div>
          <div><CopyOutlined/></div>
          <div><EnvironmentOutlined/></div>
          <div><EditOutlined/></div>
          <div><FilePdfOutlined/></div>
          <div><MailOutlined/></div>
          <div><ClockCircleOutlined/></div>
          <div><StarOutlined/></div>
          <div><BarsOutlined/></div>
          <div><QrcodeOutlined/></div>
          <div><LinkOutlined/></div>
          <div><HeartOutlined/></div>
          <div><GlobalOutlined/></div>
          <div><ShopOutlined/></div>
          <div><CalendarOutlined/></div>
          <div><PictureOutlined/></div>
          <div><BgColorsOutlined/></div>
          <div><SettingOutlined/></div>
          <div><MessageOutlined/></div>
          <div><PhoneOutlined/></div>
          <div><HomeOutlined/></div>
          <div><AppstoreOutlined/></div>
          <div><CreditCardOutlined/></div>
          <div><DollarOutlined/></div>
          <div><WarningOutlined/></div>
          <div><CheckCircleOutlined/></div>
          <div><QuestionCircleOutlined/></div>
        </div>
      </section>
    </div>
  )
}